<template>
    <section class="artstation">
        <div class="panel">
            <div class="panel-heading">
                <h2>ArtStation</h2>
            </div>
            <div class="panel-body">
                <div v-if="text.intro" v-html="text.intro[0].text"></div>
                <form @submit.prevent="submit()" v-if="!artstation">
                    <div class="form-group">
                        <input v-model="email" type="email" class="form-control" placeholder="ArtStation Email Address">
                    </div>
                    <div class="form-group">
                        <button type="submit" class="btn btn-success">Submit</button>
                    </div>
                </form>
                <div v-else>Your submitted ArtStation email address is {{artstation.email}}</div>
            </div>
        </div>
    </section>
</template>
<script>

import artstation from '../services/artstation';
import cms from '../services/cms';
import { groupBy } from 'lodash';
import toastr from 'toastr';

export default {
    data() {
        return {
            artstation: null,
            email: null,
            text: null
        }
    },
    components: {

    },
    mounted() {
        this.get();
        this.getText();
    },
    methods: {
        
        getText() {
            cms.get('ArtStation').then((response)=> {
                this.text = groupBy(response.components, (c)=> { return c.name });
            });
        },

        get() {
            artstation.get().then((response) => {
                if (response.data.students.length > 0) {
                	this.artstation = response.data.students[0];
                }
            })
        },
        submit() {
        	if (!this.email) {
        		toastr.error('Please enter your email address');
        		return false;
        	}
        	const data = {
        		email: this.email
        	}

        	artstation.submit(data).then((response)=> {
        		console.log(response)
        		if (response.data.success === true) {
        			toastr.success('Submitted');
        			this.get();
        		} else {
        			toastr.error('Error submitting');
        		}
        	})

        }
    },
    computed: {

    }
}

</script>
<style lang="scss" scoped>
section.artstation .panel-body {
    padding: 2rem;
}

</style>



// WEBPACK FOOTER //
// ArtStation.vue?55cec160